/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdSortEnum {
    ID = 'id',
    PRIORITY = 'priority',
    START_DATE = 'start_date',
    END_DATE = 'end_date',
}
